const CONSENT_KEY = "anyhomes_cookie_consent";
const OPEN_SETTINGS_EVENT = "anyhomes:open-cookie-settings";

export const COOKIE_CATEGORIES = ["necessary", "analytics", "marketing"];

const consentStateToGtag = (analytics, marketing) => {
  try {
    if (typeof window === "undefined" || !window.dataLayer) return;
    const state = {
      consent: "update",
      analytics_storage: analytics ? "granted" : "denied",
      ad_storage: marketing ? "granted" : "denied",
      ad_user_data: marketing ? "granted" : "denied",
      ad_personalization: marketing ? "granted" : "denied",
    };
    window.dataLayer.push(state);
    // Compatibilité gtag/GA4 + PostHog (has_opted_out etc.)
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: analytics ? "granted" : "denied",
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: marketing ? "granted" : "denied",
        ad_personalization: marketing ? "granted" : "denied",
      });
    }
    const evt = new CustomEvent("anyhomes:consent-updated", {
      detail: { analytics, marketing },
    });
    window.dispatchEvent(evt);
  } catch (e) {
    /* ignore */
  }
};

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      necessary: true,
      analytics: Boolean(parsed.analytics),
      marketing: Boolean(parsed.marketing),
    };
  } catch (e) {
    return null;
  }
}

export function hasConsent() {
  return getStoredConsent() !== null;
}

export function saveConsent(categories) {
  const consent = {
    necessary: true,
    analytics: Boolean(categories.analytics),
    marketing: Boolean(categories.marketing),
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch (e) {
    /* stockage indisponible : on ignore */
  }
  consentStateToGtag(consent.analytics, consent.marketing);
  return consent;
}

export function acceptAll() {
  return saveConsent({ analytics: true, marketing: true });
}

export function rejectAll() {
  return saveConsent({ analytics: false, marketing: false });
}

export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_EVENT));
}

export function onOpenCookieSettings(handler) {
  const listener = (e) => handler(e);
  window.addEventListener(OPEN_SETTINGS_EVENT, listener);
  return () => window.removeEventListener(OPEN_SETTINGS_EVENT, listener);
}

export function onConsentUpdated(handler) {
  const listener = (e) => handler(e?.detail);
  window.addEventListener("anyhomes:consent-updated", listener);
  return () => window.removeEventListener("anyhomes:consent-updated", listener);
}